/* 🤖 this file was generated by svg-to-ts */
export const matIcon60Fps: {
  name: '60-fps';
  data: string;
} = {
  name: '60-fps',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 8v8h-4V8h4m0-3h-4c-1.66 0-3 1.34-3 3v8c0 1.66 1.34 3 3 3h4c1.66 0 3-1.34 3-3V8c0-1.66-1.34-3-3-3zm-9 3V5H5C3.34 5 2 6.34 2 8v8c0 1.66 1.34 3 3 3h3c1.66 0 3-1.34 3-3v-3c0-1.66-1.34-3-3-3H5V8h5zm-2 5v3H5v-3h3z"/></svg>`
};
